import { useQuery } from "@tanstack/react-query";
import { getComedianStripeStatus } from "../client/manager/stripe";

interface ComedianStripeStatus {
  hasStripeAccount: boolean;
  hasSubscriptionProduct: boolean;
  isLoading: boolean;
  refetch: () => Promise<unknown>;
}

export function useComedianStripeStatus(
  comedianId: string,
  initialHasStripe = false
): ComedianStripeStatus {
  const query = useQuery({
    queryKey: ["comedian", comedianId, "stripe-status"],
    queryFn: () => getComedianStripeStatus(comedianId),
    staleTime: 30_000,
    enabled: !initialHasStripe,
  });

  return {
    hasStripeAccount:
      initialHasStripe || (query.data?.hasStripeAccount ?? false),
    hasSubscriptionProduct: query.data?.hasSubscriptionProduct ?? false,
    isLoading: query.isLoading,
    refetch: query.refetch,
  };
}
